import { useTranslation } from "react-i18next";
import type { TOptions } from "i18next";

type Namespace = "common" | "admin" | "documents" | "notifications" | "payments" | "statuses";

export function useAppTranslation(defaultNs: Namespace = "common") {
  const { t } = useTranslation();

  function translate(
    key: string,
    options?: TOptions,
    ns?: Namespace
  ) {
    return t(key, {
      ns: ns ?? defaultNs,
      ...options,
    });
  }

  return { t: translate };
}